module.exports = __webpack_public_path__ + "static/media/hero1.c856af77.jpg";